var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStateInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.541,
    height: 17.538,
    viewBox: "0 0 17.541 17.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info_Icon",
    "data-name": "Info Icon",
    transform: "translate(0.771 0.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": "!",
    transform: "translate(0 0.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_Copy_4",
    "data-name": "Shape Copy 4",
    d: "M7.453.006C7.2.028,6.88.066,6.679.1A8.016,8.016,0,0,0,.419,5.406,8.461,8.461,0,0,0,.03,7.149a12,12,0,0,0,0,1.7A8.033,8.033,0,0,0,7.148,15.97a12,12,0,0,0,1.7,0A8.033,8.033,0,0,0,15.97,8.853a12,12,0,0,0,0-1.7A8.032,8.032,0,0,0,8.86.034C8.66.01,7.642-.01,7.453.006Z",
    transform: "translate(0 -0.367)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Final_payment_amount",
    "data-name": "Final payment amount",
    d: "M2.076-2.676H3.684v-.3c.072-.636.684-1.128,1.26-1.68A2.593,2.593,0,0,0,5.928-6.54c0-1.272-.9-2.16-2.664-2.16A2.7,2.7,0,0,0,.3-6.048H1.968A1.216,1.216,0,0,1,3.156-7.284.809.809,0,0,1,4.08-6.4c0,.48-.384.864-.816,1.284A2.93,2.93,0,0,0,2.076-3.036ZM2.868.108A1.061,1.061,0,0,0,3.96-.924,1.063,1.063,0,0,0,2.868-1.968a1.067,1.067,0,0,0-1.1,1.044A1.064,1.064,0,0,0,2.868.108Z",
    transform: "translate(5 12)",
    fill: "#3c3c3b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateInfoIcon);
export default __webpack_public_path__ + "static/media/state-info-icon.0695cdca.svg";
export { ForwardRef as ReactComponent };